export const PAID_BY_OTHER_TYPES = [
  { id: 0, name: 'Seller' },
  { id: 1, name: 'Lender' },
  { id: 2, name: 'Third Party' },
  { id: 3, name: 'Building (Other than Seller)' },
  { id: 4, name: 'Employer' },
  { id: 5, name: 'Federal Agency' },
  { id: 6, name: 'Local Agency' },
  { id: 7, name: 'Non Parent Relative' },
  { id: 8, name: 'Parent' },
  { id: 9, name: 'Real Estate Agent' },
  { id: 10, name: 'State Agency' },
  { id: 11, name: 'Unrelated Friend' },
];

export const PAID_TO = [
  { id: 999, name: 'Select' },
  { id: 1, name: 'Lender' },
  { id: 2, name: 'Broker' },
  { id: 3, name: 'Investor' },
  { id: 4, name: 'Other' },
  { id: 5, name: 'Affiliate of Lender' },
  { id: 6, name: 'Affiliate of Broker' },
];

export const RESPONSIBLE_PARTY = [
  { id: 0, name: 'Buyer', disabled: false },
  { id: 1, name: 'Seller', disabled: false },
];

export const PAID_BY = [
  { id: 0, name: 'Borrower', disabled: false },
  { id: 1, name: 'Seller', disabled: false },
];

export const ESCROW_TYPE = [
  { id: 0, value: 'Select' },
  { id: 1, value: 'Waive All' },
  { id: 2, value: 'Not Waived' },
  { id: 3, value: 'Waive Taxes Only' },
  { id: 4, value: 'Waive Insurance Only' },
];

export const PREPAID_ESCROW = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'Assessment' },
  { id: 2, name: 'City Property Tax' },
  { id: 3, name: 'County Property Tax' },
  { id: 4, name: 'Earthquake Insurance' },
  { id: 5, name: 'Flood Insurance' },
  { id: 6, name: 'Hazard Insurance' },
  { id: 7, name: 'Mortgage Insurance' },
  { id: 8, name: 'Other' },
  { id: 9, name: 'School Property Tax' },
  { id: 10, name: 'Town Property Tax' },
  { id: 11, name: 'Village Property Tax' },
  { id: 12, name: 'Windstorm Insurance' },
];

export const DISBURSEMENT_SCHED = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'Not Escrowed' },
  { id: 2, name: 'Monthly' },
  { id: 3, name: 'Quarterly' },
  { id: 4, name: 'Semi-Annually' },
  { id: 5, name: 'Annually' },
  { id: 6, name: 'Other' },
];

export const DISBURSEMENT_START = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'January' },
  { id: 2, name: 'February' },
  { id: 3, name: 'March' },
  { id: 4, name: 'April' },
  { id: 5, name: 'May' },
  { id: 6, name: 'June' },
  { id: 7, name: 'July' },
  { id: 8, name: 'August' },
  { id: 9, name: 'September' },
  { id: 10, name: 'October' },
  { id: 11, name: 'November' },
  { id: 12, name: 'December' },
  { id: 13, name: 'Closing Date' },
];

export const FEESHEET_TYPE = [
  { id: 4, name: 'AIO Pre-Application Fee Estimate Worksheet', disabled: false },
  { id: 1, name: 'Expanded (2 pages)', disabled: false },
  { id: 2, name: 'Summarized V1 (1 page)', disabled: false },
  { id: 3, name: 'Summarized V2 (1 page)', disabled: false },
];

export const UPFRONT_TYPE = [
  { id: '', name: 'Select' },
  { id: 'paidInCash', name: 'Paid In Cash' },
  { id: 'financed', name: 'Financed' },
];

export const OTHER_CREDIT = [
  { id: 0, value: 'Select' },
  { id: 1, value: 'Cash Deposit on Sales Contract' },
  { id: 2, value: 'Seller Credit' },
  { id: 4, value: 'Relocation Funds' },
  { id: 5, value: 'Employer Assisted Housing' },
  { id: 6, value: 'Lease Purchase Funds' },
  { id: 7, value: 'Borrower Paid Fees' },
  { id: 8, value: 'Other' },
];

export const BUYDOWNS = [
  { id: 0, name: 'None' },
  { id: 1, name: '5-4-3-2-1' },
  { id: 2, name: '4-3-2-1' },
  { id: 3, name: '3-2-1' },
  { id: 4, name: '2-1' },
  { id: 5, name: '1-0' },
  { id: 6, name: 'Compressed 5-4-3-2-1' },
  { id: 7, name: 'Compressed 4-3-2-1' },
  { id: 8, name: 'Compressed 3-2-1' },
  { id: 9, name: 'Compressed 2-1' },
  { id: 10, name: 'Compressed 1-0' },
  { id: 11, name: 'Halfstep from 5' },
  { id: 12, name: 'Halfstep from 4' },
  { id: 13, name: 'Halfstep from 3' },
  { id: 14, name: 'Halfstep from 2.5' },
  { id: 15, name: 'Halfstep from 2' },
  { id: 16, name: 'Halfstep from 1.5' },
  { id: 17, name: 'Halfstep from 1' },
  { id: 18, name: 'Halfstep from 0.5' },
];

export const addPhotoTooltipMsg = '<b>Yes</b> will pull the photo uploaded to My Profile in Marketing Hub';
export const uploadLOPhotoMsg =
  '<i>Please ensure the LO\'s photo is uploaded to <a class="color-primary ps-1 fw-bold" href="https://hub.cmgfi.com/EmailSignatures" target="_blank">Marketing Hub</a></i>';

// Pest Inspection is required
export const pestInspectionStates = [
  'AL',
  'AR',
  'AZ',
  'CA',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'MO',
  'MS',
  'NC',
  'NJ',
  'NM',
  'OH',
  'OK',
  'RI',
  'SC',
  'TN',
  'TX',
  'VA',
  'WV',
];

// Pest Inspection may be required
export const pestInspectionOptionalStates = ['AK', 'ID', 'ME', 'MI', 'MN', 'MT', 'NH', 'ND', 'OR', 'SD', 'VT', 'WA', 'WY'];

// Pest Inspection may be required in some counties
export const pestInspectionSomeCountiesStates = ['CO', 'IA', 'NE', 'NY', 'NV', 'PA', 'UT', 'WI'];

export const structuralEngineeringNotRequiredStates = ['AK', 'HI'];
